// eslint-disable-next-line import/named
import { schema } from 'normalizr'
import { CommonTemplateDto, TeamTemplateDto } from '~/remote/api-spec'
import RemoteModel from '~/models/RemoteModel'
import Team from '~/models/Team'

export interface Template {
  id?: string
  type: string
  template: string
  teamId?: string
  automaticForTeams?: Array<string>
  createdOn?: string
  enabled: boolean
}

const commonTemplateSchema = new schema.Entity<CommonTemplateDto>(
  'commonTemplate',
  {}
)

const teamTemplateSchema = new schema.Entity<TeamTemplateDto>('teamTemplate', {
  team: Team.schema,
})

export class CommonTemplate extends RemoteModel implements CommonTemplateDto {
  id!: string
  type!: string
  template!: string
  automaticForTeams?: Array<string>
  createdOn?: string
  enabled!: boolean

  static schema: schema.Entity = commonTemplateSchema
  static arraySchema: schema.Array = new schema.Array(commonTemplateSchema)
}

export class TeamTemplate extends RemoteModel implements TeamTemplateDto {
  id!: string
  type!: string
  template!: string
  teamId!: string
  automaticForTeams?: Array<string>
  createdOn?: string
  enabled!: boolean

  static schema: schema.Entity = teamTemplateSchema
  static arraySchema: schema.Array = new schema.Array(teamTemplateSchema)
}

export default {}
